import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import InlineSVG from 'svg-inline-react'

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const TopBarTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #323751;
`

const TopBar = () => {

  return (
    <TopBarWrapper>
      <TopBarTitle>
        Organisations
      </TopBarTitle>
    </TopBarWrapper>
  )
}

export default TopBar
